import React from 'react';

import Checkbox from '@fmbt/ui/Checkbox';

type AutoRenewCheckboxProps = {
  checked: boolean;
  disabled: boolean;
  onAutoRenewUpdate: (subscriptionId: number, isAutoRenewActive: boolean) => void;
  subscriptionId: number;
};

export function AutoRenewCheckbox({
  checked,
  disabled,
  onAutoRenewUpdate,
  subscriptionId
}: AutoRenewCheckboxProps) {
  return (
    <Checkbox
      disabled={disabled}
      checked={checked}
      onChange={() => { onAutoRenewUpdate(subscriptionId, !checked); }}
    />
  );
}
